import { useMemo } from 'react';
import { getDaysInMonth, getNextMonthDay } from '../../helpers/dateHelper';
import { useSystemSettings } from './SystemSettingsProvider';
import { useSelectedDate } from '../useSelectedDate';

export const useNextAvailabilityPeriod = (date?: Date) => {
  const availabilityDeadline = useSystemSettings(state => state.settings.availabilityDeadlineSettings.deadlineMonthDay);
  const availabilityDeadlineOptional = useSystemSettings(
    state => state.settings.availabilityDeadlineSettings.sendReminders
  );

  return useMemo(() => {
    const dateToUse = date ? date : new Date();
    const nextDeadline = getNextMonthDay(dateToUse, availabilityDeadline);
    const nextPeriodStart = getNextMonthDay(nextDeadline, 1);
    const nextPeriodEnd = getNextMonthDay(nextPeriodStart, 31);

    return { nextPeriodStart, nextPeriodEnd, nextDeadline: availabilityDeadlineOptional ? undefined : nextDeadline };
  }, [availabilityDeadline, availabilityDeadlineOptional, date]);
};

export const useDaysInMonth = (date: Date, padWithExtra?: string) => {
  return useMemo(() => {
    let days = getDaysInMonth(date.getMonth(), date.getFullYear());

    if (padWithExtra) {
      const extraStartDay = new Date(days[0]);
      extraStartDay.setUTCDate(extraStartDay.getUTCDate() - 1);

      const extraEndDay = new Date(days[days.length - 1]);
      extraEndDay.setUTCDate(extraEndDay.getUTCDate() + 1);

      days = [extraStartDay, ...days, extraEndDay];
    }

    return days;
  }, [date, padWithExtra]);
};
